import '../styles/main.css'
import '@/lib/select.js'
import lazim from 'lazim'
import app from '@/app.js'
import router from '@/router.js'
import { fetchCart } from '@/lib/cart.js'

/**
 * store binding fn
 */
const images = lazim()

/**
 * bind on page load
 */
images()

router.on('after', () => {
  app.unmount()
  app.mount()

  /**
   * bind new images
   */
  images()

  /**
   * bind animations
   */
})

/**
 * load any data that your site needs on fist load
 */
Promise.all([
  fetchCart()
]).then(([ cart ]) => {
  /**
   * add the cart data to the picoapp instance
   */
  app.hydrate({ cart })

  /**
   * mount any components defined on the page
   */
  app.mount()
})

document.addEventListener('shopify:section:load', event => {
  app.unmount();
  app.mount();
  images();
}, true);

document.addEventListener('shopify:section:select', event => {
  app.unmount();
  app.mount();
  images();
}, true);

document.addEventListener('shopify:block:select', event => {
  app.unmount();
  app.mount();
  images();
}, true);